<mat-form-field appearance="outline" class="no-line">
    <mat-select class="select" placeholder="Interval" (ngModelChange)="CategorySelected($event)"
        [(ngModel)]="selectedCategory" disableOptionCentering>
        <mat-option [value]="category.value" *ngFor="let category of categories">
            {{category.name}}
        </mat-option>
    </mat-select>
</mat-form-field>